import { render, staticRenderFns } from "./SCAPaymentRequestButton.vue?vue&type=template&id=51e07865&scoped=true&"
import script from "./SCAPaymentRequestButton.vue?vue&type=script&lang=js&"
export * from "./SCAPaymentRequestButton.vue?vue&type=script&lang=js&"
import style0 from "./SCAPaymentRequestButton.vue?vue&type=style&index=0&id=51e07865&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "51e07865",
  null
  
)

export default component.exports